import client from '@/shared/apis/client'
import {
  Patient,
  PaginatedPatientsResponse,
  PaginatedVisitsResponse,
  PatientSearchParams,
} from '@/features/patients/types/patients'

// 患者一覧取得（ページネーション対応）
export const getPatients = async (
  params?: PatientSearchParams
): Promise<PaginatedPatientsResponse> => {
  const response = await client.get('/api/patients/', { params })
  return response.data
}

// 特定患者の詳細情報取得
export const getPatient = async (patientId: string): Promise<Patient> => {
  const response = await client.get(`/api/patients/${patientId}/`)
  return response.data
}

// 患者の来院履歴取得
export const getPatientVisits = async (
  patientId: string,
  params?: { page?: number; limit?: number }
): Promise<PaginatedVisitsResponse> => {
  const response = await client.get(`/api/patients/${patientId}/visits/`, {
    params,
  })
  return response.data
}
